import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { useProvidedId, getDescriptionId } from '../hooks/id-provider.js';
import { description } from './description.css.js';

/**
 * A reusable description component that renders as a `<p>` element. Automatically linked to other
 * components via `aria-describedby`.
 */
function Description(props) {
    const id = useProvidedId();
    const descriptionId = getDescriptionId(id);
    return (jsx("p", { "data-fpl-component": "", className: clsx(description, props.className), id: descriptionId, children: props.children }));
}
Description.displayName = 'Description';

export { Description };
//# sourceMappingURL=description.js.map
